<div class="holiday-call-flow-form" data-automation="holiday-call-flow-form">
  <div class="holiday-call-flow-form__actions mb-2 gap-2">
    <ziro-button
      [label]="
        'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.holiday.add_holiday.label' | translate
      "
      [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
      [icon]="ZiroIcons.ADD"
      [buttonSize]="ButtonSizes.SMALL"
      (clicked)="openCreateHolidayModal()"
      dataAutomation="add-new-holiday-button"
    ></ziro-button>
    @if (formData?.holidaySchedule?.value) {
      <ziro-button
        [label]="
          'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.holiday.edit_holiday.label' | translate
        "
        [buttonStyle]="ButtonStyles.OUTLINE_DEFAULT"
        [icon]="ZiroIcons.EDIT"
        [buttonSize]="ButtonSizes.SMALL"
        (clicked)="openEditHolidayModal()"
        dataAutomation="edit-holiday-button"
      ></ziro-button>
    }
  </div>
  <ziro-text [fieldId]="'name'"></ziro-text>
  <div class="d-flex align-items-end gap-2">
    <div class="flex-grow-1">
      <ziro-select [fieldId]="'holidaySchedule'"></ziro-select>
    </div>
  </div>

  @if (selectedDateRanges.length) {
    <div class="mt-2 row" data-automation="holiday-date-ranges">
      <label class="col-form-label col-lg-3 text-lg-end ziro-forms-label">
        {{ 'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.holiday.date_ranges.label' | translate }}
      </label>
      <ul class="list-unstyled mb-0 col-lg-9">
        @for (range of selectedDateRanges; track $index) {
          <li class="py-2 small text-muted">
            {{ range.start | date: 'MMMM d, y, h:mm a' }} – {{ range.end | date: 'MMMM d, y, h:mm a' }}
          </li>
        }
      </ul>
    </div>
  }
</div>
